<script setup>

import { ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import { DateTime } from "luxon";
import RetornarCotacaoItemModal from "./RetornarCotacaoItemModal.vue";
import CriarPedidoDeCompraModal from "./CriarPedidoDeCompraModal.vue";
import CotacaoDePedidoDeCompraItemService from "../../api/v2/services/CotacaoDePedidoDeCompraItemService.js";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore";

import { runAction } from "../../services/actionService.js";

import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// var pdfMake = require("pdfmake/build/pdfmake.js");
// var pdfFonts = await require("pdfmake/build/vfs_fonts.js");


// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// pdfMake.createPdf(definition).download(name);
// return await pdfMake;
//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================= Colaborador Store ========================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 
const compradorNome = ref(colaboradorStore.colaborador.nome);

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const retornandoCotacaoItens = ref(false);
const criandoPedidos = ref(false);
const controlesDesativados = ref(false);

//==================================================================//
//=========================== Cotacoes =============================//
//==================================================================//

const cotacoes = ref([]);
const cotacoesLoading = ref(true);
let cotacoesSelecionadas = ref([]);
let cotacoesExpandidas = ref([]);

//==================================================================//
//======================== Cotacoes Itens ==========================//
//==================================================================//

let cotacoesItensSelecionadas = ref([]);

//==================================================================//
//=======================--= Fornecedores ===--=====================//
//==================================================================//

const fornecedores = ref([]);
const fornecedoresCarregados = ref(false);

//==================================================================//
//================ Parcelas Condições de Pagamento =================//
//==================================================================//

const parcelasCondicoesDePagamento = ref([]);
const parcelasCondicoesDePagamentoCarregados = ref(false);

//==================================================================//
//====================== Unidades dos Itens ========================//
//==================================================================//

const unidadesItens = ref([]);
const unidadesItensCarregados = ref(false);

//==================================================================//
//======================== Campos de Busca =========================//
//==================================================================//

let buscaJobs = ref([]);
let buscaJobSelecionado = ref("");

let buscaOrdensDeServico = ref([]);
let buscaOrdemDeServicoSelecionada = ref("");

let buscaPalavrasChave = ref([]);
let buscaPalavraChaveSelecionada = ref("");

let buscaGeral = ref("");

//==================================================================//
//======================== Cotacoes Header =========================//
//==================================================================//

let cotacoesHeaders = [
    { text: '',                     value: 'pdf',           class:"c-table__header",    cellClass:'c-table__item', filterable: false, width:"50",},
    { text: 'N° da Cotação',        value: 'codigo',        class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: '', value: 'data-table-expand' },
]

//==================================================================//
//===================== Cotacoes Itens Header ======================//
//==================================================================//

const filterJob = (jobCodigo) =>{

    if (!buscaJobSelecionado.value) {
          return true;
    }

    return jobCodigo.toLowerCase().includes(buscaJobSelecionado.value.toLowerCase());

}

const filterOS = (osCodigo) =>{

    if (!buscaOrdemDeServicoSelecionada.value) {
        return true;
    }

    return osCodigo.toLowerCase().includes(buscaOrdemDeServicoSelecionada.value.toLowerCase());

}

let cotacoesItensHeaders = [
    { text: 'Job',                  value: 'jobCodigo',                      class:"c-table__header",    cellClass:'c-table__item', filter: filterJob},
    { text: 'OS',                   value: 'osCodigo',                       class:"c-table__header",    cellClass:'c-table__item', filter: filterOS},
    { text: 'Sequência',            value: 'osItemSequencia',                class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Código do Item',       value: 'osItemItemCodigo',               class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Descrição',            value: 'osItemDescricao',                class:"c-table__header",    cellClass:'c-table__item',  width:"550"},
    { text: 'Data de Solicitação',  value: 'osItemDataSolicitacao',          class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Necessidade',  value: 'osItemDataNecessidade',          class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Entrega',      value: 'osItemDataEntrega',              class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Quantidade Solicitada',value: 'osItemQuantidade',               class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Unidade Solicitada',   value: 'osItemUnidade.sigla',            class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Valor Disponivel',     value: 'osItemValorDisponivel',          class:"c-table__header",    cellClass:'c-table__item', filterable: false,  width:"150", },
    { text: 'Status (Item)',        value: 'osItemStatus',                   class:"c-table__header",    cellClass:'c-table__item', filterable: false},
]

//==================================================================//
//===================== Item Campos Formatados =====================//
//==================================================================//

const dataEntregaFormatada = (item) =>{

    let dataEntrega = DateTime.fromISO(item.osItemDataEntrega)

    if(!dataEntrega.isValid){
        return "";
    }

    return dataEntrega.toFormat("dd/MM/yyyy");
 
};

//==================================================================//
//=================== Load Cotacoes (Com Itens) ====================//
//==================================================================//

const loadCotacoes = async () =>{
    cotacoesSelecionadas.value = [];

    const cotacoesResponse = await ERP.getManyWithView(View.COTACAO_PEDIDO_DE_COMPRA_CRIAR_PEDIDO_DE_COMPRA,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore.usuario.id
        },
    ]);

    cotacoes.value = cotacoesResponse.data;

    fillBuscaJobs();
    fillBuscaOrdensDeServico();
    fillBuscaPalavrasChave();
    clearBuscaGeral();

    cotacoesLoading.value = false;
};

//==================================================================//
//======================= Load Fornecedores ========================//
//==================================================================//

const loadFornecedores = async () =>{

    const fornecedoresResponse = await ERP.getManyWithView(View.COTACAO_PEDIDO_DE_COMPRA_FORNECEDORES);
    if(fornecedoresResponse.status != 200){
        throw new Error("Falha ao obter os Fornecedores"); 
    }

    fornecedores.value = fornecedoresResponse.data;

};

//==================================================================//
//============== Load Parcelas Condicoes De Pagamento ==============//
//==================================================================//

const loadParcelasCondicoesDePagamento = async () =>{

    const parcelasCondicoesDePagamentoResponse = await ERP.getManyWithView(View.COTACAO_PEDIDO_DE_COMPRA_PARCELAS_CONDICAO_DE_PAGAMENTO);
    if(parcelasCondicoesDePagamentoResponse.status != 200){
        throw new Error("Falha as Condições de Pagamento das Parcelas"); 
    }

    parcelasCondicoesDePagamento.value = parcelasCondicoesDePagamentoResponse.data;

};

//==================================================================//
//==================== Load Unidades dos Itens =====================//
//==================================================================//

const loadUnidadesItens = async () =>{

    const unidadesItensResponse = await ERP.getManyWithView(View.COTACAO_PEDIDO_DE_COMPRA_ORDEM_DE_SERVICO_ITENS_UNIDADES);
    if(unidadesItensResponse.status != 200){
        throw new Error("Falha ao Carregar as Unidades dos Itens"); 
    }

    unidadesItens.value = unidadesItensResponse.data;

};

//==================================================================//
//======================== Fill Buscadores =========================//
//==================================================================//

const fillBuscaJobs = () =>{
    buscaJobSelecionado.value = "";

    buscaJobs.value = cotacoes.value.map(({itens})=>
        itens.map(({jobCodigo})=>jobCodigo)
    ).flat();

};

const fillBuscaOrdensDeServico = () =>{
    buscaOrdemDeServicoSelecionada.value = "";

    buscaOrdensDeServico.value = cotacoes.value.map(({itens})=>
        itens.map(({osCodigo})=>osCodigo)
    ).flat();

};

const fillBuscaPalavrasChave = () =>{
    buscaPalavraChaveSelecionada.value = "";
    buscaPalavrasChave.value = ["Teste1","Teste2"];
};

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};

//==================================================================//
//=================== Ao Retornar Cotacao Itens ====================//
//==================================================================//

const aoRetornarCotacaoItens = async ()=>{

    if(UtilArray.isEmpty(cotacoesItensSelecionadas.value)){
        return false;
    }

    retornandoCotacaoItens.value = true;

}

//==================================================================//
//=============== Ao Decidir Retornar Cotacao Itens  ===============//
//==================================================================//

const aoDecidirRetornarCotacaoItens = async (decisao)=>{

    if(decisao.resultado == true){

        let cotacoesItensSelecionadasIDs = cotacoesItensSelecionadas.value.map(({id}) => id);

        let justificativa = decisao.justificativa;

        let cotacaoItensRetornadosResponse = await CotacaoDePedidoDeCompraItemService.retornarCotacaoItens(cotacoesItensSelecionadasIDs,justificativa);
        if(cotacaoItensRetornadosResponse.status != 200){
            throw new Error("Falha ao retornar os Itens da Cotação para o Coordenador"); 
        }

    }

    retornandoCotacaoItens.value = false;
    loadCotacoes();

}

//==================================================================//
//======================== Ao Criar Pedidos ========================//
//==================================================================//

const aoCriarPedido = async ()=>{

    if(UtilArray.isEmpty(cotacoesItensSelecionadas.value)){
        return false;
    }

    criandoPedidos.value = true;

    if(UtilArray.isEmpty(fornecedores.value)){
        await loadFornecedores();
        fornecedoresCarregados.value = true;
    }

    if(UtilArray.isEmpty(parcelasCondicoesDePagamento.value)){
        await loadParcelasCondicoesDePagamento();
        parcelasCondicoesDePagamentoCarregados.value = true;
    }

    if(UtilArray.isEmpty(unidadesItens.value)){
        await loadUnidadesItens();
        unidadesItensCarregados.value = true;
    }

}

const aoDecidirCriarPedido = async ()=>{

    criandoPedidos.value = false;
    await loadCotacoes();

}

//==================================================================//
//======================= Ao Expandir Cotacao ======================//
//==================================================================//

const aoExpandirCotacao = (item, slot)=>{

    slot.expand(!slot.isExpanded);

};

//==================================================================//
//=============== Download PDF da Cotação do Pedido ================//
//==================================================================//

const downloadPDFCotacaoDoPedido = async (id) =>{

    let pdfResponse = await runAction({name:"PDF Cotação do Pedido de Compra"},{
        id: id,
    });

    if(pdfResponse.footer){
        let columns = pdfResponse.footer;
        console.log("COLUMNS >>> ", columns)

        pdfResponse.data.footer = function(currentPage, pageCount) { //currentPage, pageCount
            // this.result.currentPage = currentPage
            // this.result.pageCount = pageCount
            
            return JSON.parse(JSON.stringify(columns));

        }
        
    }

    // definition.footer = function(currentPage, pageCount) { 
    // return columns
    //}

    console.log(pdfResponse);

    let teste = pdfMake.createPdf(pdfResponse.data).download("Cotação do Pedido de Compra");

    console.log(teste);

};

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadCotacoes();

});

//==================================================================//
//========================= Watch Controle =========================//
//==================================================================//

watch(retornandoCotacaoItens, (novoValor) => {
    controlesDesativados.value = novoValor;
});

watch(criandoPedidos, (novoValor) => {
    controlesDesativados.value = novoValor;
});

//==================================================================//
//=================== Watch Cotacoes Selecionadas ==================//
//==================================================================//

watch(cotacoesSelecionadas, (cotacoes) => {

    cotacoesItensSelecionadas.value = [];

    if(!UtilArray.isEmpty(cotacoes)){

        cotacoesItensSelecionadas.value = cotacoes.map(({itens})=>

            itens

        ).flat();
        
    }
    
});

</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Criar Pedido de Compra
        </h2>

        <v-card>

            <v-card-title
                class="c-table-holder"
            >

                <h3
                    class="c-table__titulo"
                >
                    Cotações
                </h3>

                <div
                    class="c-table__buscas"
                >

                    <v-select
                        label="Job"
                        class="c-busca__job"
                        v-model="buscaJobSelecionado"
                        :items="buscaJobs"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="OS"
                        class="c-busca__os"
                        v-model="buscaOrdemDeServicoSelecionada"
                        :items="buscaOrdensDeServico"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="controlesDesativados"
                    ></v-select>

                    <v-select
                        label="Palavras Chaves"
                        class="c-busca__palavraChave"
                        v-model="buscaPalavraChaveSelecionada"
                        :items="buscaPalavrasChave"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        disabled
                    ></v-select>

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <div
                    class="c-table__controles"
                >
                
                    <div
                        class="c-controles__compradores"
                    >

                        <v-chip
                            class="c-comprador"
                            label
                        >

                            <v-icon left>
                                mdi-account-circle-outline
                            </v-icon>
                            Comprador:
                            {{compradorNome}}

                        </v-chip>

                    </div>

                    <div
                        class="c-controles__botao-esquerda"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    v-on:click="aoRetornarCotacaoItens"
                                    :disabled="controlesDesativados"
                                    :loading="retornandoCotacaoItens"
                                >
                                    Retornar
                                    
                                </v-btn>

                            </template>

                            <p 
                                class="c-tooltip-retornar__mensagem"
                            >
                                <span>Retornar Itens das Cotações</span>
                                <span>Itens não Preenchidos retornam para o Coordenador</span>
                                <span>Itens já Preenchidos retornam para Cotação novamente</span>
                            </p>

                        </v-tooltip>

                    </div>

                    <div
                        class="c-controles__botao-direita"
                    >

                        <v-tooltip bottom>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="aoCriarPedido"
                                    :disabled="controlesDesativados"
                                    :loading="criandoPedidos"
                                >
                            
                                Criar
                                
                            </v-btn>

                            </template>

                            <span>Criar um Pedido de Compra</span>

                        </v-tooltip>

                    </div>

                </div>

            </v-card-title>

            <v-data-table
                class="c-table"
                v-model="cotacoesSelecionadas"
                :headers="cotacoesHeaders"
                :items="cotacoes"
                :items-per-page="-1"
                :expanded.sync="cotacoesExpandidas"
                :loading="cotacoesLoading"
                loading-text="Carregando... Por favor, aguarde."
                select-strategy="all"
                item-key="id"
                elevation="1"
                show-select
                show-expand
                return-object
                @click:row="aoExpandirCotacao"
            >

                <template v-slot:item.pdf="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-visualizar-pedido mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="downloadPDFCotacaoDoPedido(item.id)"
                            >

                                <v-icon dark>
                                    mdi-download
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Visualizar PDF da Cotação</span>

                    </v-tooltip>

                </template>

                <template v-slot:expanded-item="{ headers, item }">

                    <td class="c-inner_table_holder" :colspan="headers.length">

                        <v-data-table
                            v-model="cotacoesItensSelecionadas"
                            :headers="cotacoesItensHeaders"
                            :items="item.itens"
                            :search="buscaGeral"
                            item-key="id"
                            elevation="0"
                            show-select
                            hide-default-footer
                        >

                            <template v-slot:item.osItemDescricao="{ item }">

                                <p
                                    class="c-cell__descricao"
                                >

                                    {{item.osItemDescricao}}

                                </p>

                            </template>

                            <template v-slot:item.osItemValorDisponivel="{ item }">

                                <vuetify-money
                                    type="number"
                                    v-model="item.osItemValorDisponivel"
                                    :readonly=true
                                    backgroundColor="transparent"
                                    :options="{
                                        prefix:'R$',
                                        precision:2
                                    }"
                                >

                                </vuetify-money>

                            </template>

                            <template v-slot:item.osItemDataEntrega="{item}">

                                {{dataEntregaFormatada(item)}}

                            </template>

                        </v-data-table>

                    </td>

                </template>
        
            </v-data-table>

        </v-card>

        <RetornarCotacaoItemModal
            :aberto="retornandoCotacaoItens"
            @update:aberto="aoDecidirRetornarCotacaoItens"
        ></RetornarCotacaoItemModal>

        <CriarPedidoDeCompraModal
            :aberto="criandoPedidos && fornecedoresCarregados && parcelasCondicoesDePagamentoCarregados && unidadesItensCarregados"
            @update:aberto="aoDecidirCriarPedido"
            :cotacoesItens="cotacoesItensSelecionadas"
            :fornecedores="fornecedores"
            :parcelasCondicoesDePagamento="parcelasCondicoesDePagamento"
            :unidadesItens="unidadesItens"
        ></CriarPedidoDeCompraModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-table__header{
    pointer-events: none;
    user-select: none; 
}

.c-table-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo ."
    "buscas controles";
    gap: 10px;
}

.c-table__title { 
    grid-area: titulo;
}

.c-cell__descricao{
    white-space: normal;
    margin: 0px !important;
}

.c-table__buscas { 
    grid-area: buscas;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    gap: 10px;
    grid-template-areas: 
        "buscaJob buscaOS buscaPalavraChave"
        "buscaGeral buscaGeral buscaGeral";
}

.c-busca__job{
    grid-area: buscaJob;
}

.c-busca__os{
    grid-area: buscaOS;
}

.c-busca__palavraChave{
    grid-area: buscaPalavraChave;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-comprador{
    width: 100%;
    min-height: 48px;
}

.c-comprador >>> .v-chip__content{
    margin: auto;
}

.c-table__controles { 
    grid-area: controles;
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-areas: 
    "compradores compradores"
    "botao-esquerda botao-direita";
    padding: 0 20px;
    gap: 10px;
}

.c-controles__compradores { 
    grid-area: compradores;
}

.c-controles__botao-esquerda { 
    grid-area: botao-esquerda;
    display: grid;
    grid-auto-flow: column;
}

.c-tooltip-retornar__mensagem{
    display: grid;
    justify-items: center;
    margin: 0;
}

.c-controles__botao-direita { 
    grid-area: botao-direita;
    display: grid;
    grid-auto-flow: column;
}

.c-table{
    display: grid;
    white-space: nowrap;
}

.c-inner_table_holder{
    padding: 8px !important;
}

@media (width <= 850px) {
    
    .c-table-holder{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "controles"
            "buscas"
        ;
    }

    .c-table__controles{
        padding: 0;
    }

}

</style>